"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function CompanyVideo(props) {
  return _react2["default"].createElement(
    "svg",
    { className: props.className, width: props.size, height: props.size, viewBox: "0 0 64 64" },
    _react2["default"].createElement("path", { fill: "#4F74B3", d: "M62.667 57.333H1.333A1.333 1.333 0 0 1 0 56V8c0-.736.597-1.333 1.333-1.333h61.333C63.403 6.667 64 7.264 64 8v48c0 .736-.597 1.333-1.333 1.333z" }),
    _react2["default"].createElement("path", { fill: "#FFF", d: "M41.333 32l-16 9.24V22.76zM26.667 13.333h10.667v1.333H26.667zM13.333 13.333H24v1.333H13.333zM40 13.333h10.667v1.333H40zM53.333 13.333H64v1.333H53.333zM0 13.333h10.667v1.333H0zM26.667 49.333h10.667v1.333H26.667zM13.333 49.333H24v1.333H13.333zM40 49.333h10.667v1.333H40zM53.333 49.333H64v1.333H53.333zM0 49.333h10.667v1.333H0z" })
  );
}

exports["default"] = CompanyVideo;
module.exports = exports["default"];